const KEY = 'personalizehq:command-recents:v1';
const LIMIT = 8;

export function readRecentCommandIds(): string[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((value): value is string => typeof value === 'string').slice(0, LIMIT) : [];
  } catch {
    return [];
  }
}

export function recordRecentCommandId(id: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify([id, ...readRecentCommandIds().filter((value) => value !== id)].slice(0, LIMIT)));
  } catch {
    // Recent history is ergonomic only; command execution must never depend on storage.
  }
}
